import Vue from 'vue';
import VueFormWizard from 'vue-form-wizard';

Vue.use(VueFormWizard)
